export default {
  tourisms: [],
  tourism: {},
  name: '',
  url: '',
  description: '',
  lat: 0.0,
  lng: 0.0,
  radius: 0
}
